export default __webpack_public_path__ + "static/media/hinted-subset-Roboto-Bold.ef6d1d09.woff";